import { useQuery } from '@tanstack/react-query';

import { getCampaigns } from '../api/ventura/contract';
import { camelCaseKeys } from '../util/object';
import { useConfig } from './useConfig';

// STAYS ON RAILS (campaigns flip scope, ACH-vrgd): the CONTRACT-nested campaigns
// index (/admin/contracts/{id}/campaigns) is a different route from the two
// ACH-served campaign reads (the IO-nested index + the shallow show) and has no ACH
// handler — see the 'campaigns' scope comment in util/apiHostFor.ts. It keeps
// calling the plain Rails apiHost.
function useContractCampaigns(contractId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['contractCampaigns', contractId],
    queryFn: () => getCampaigns(apiHost, contractId),
    select: camelCaseKeys
  });

  return query;
}

export default useContractCampaigns;
